// extracted by mini-css-extract-plugin
export default {"root":"_3JqP6","small":"_2JD-h","normal":"_1MSAX"};